import pageConfig from '@PROJECT_ROOT/responsiveFrontendPagesConfiguration.json';
import { apiFetchData } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/apiService';

// TODO: #58308 Privremeno, nakon comitt-a prve verzije će se uklonit ili doradit.
// Doradit da svaka metoda završava na "Data".
// ZBOG SSR-a pokušaj centraliziranja tako da smanjimo mogućnost razlikovanja i ponavljanja logike za API request-ove na SSR-u i CSR-u.
// Servis za handle-anje svih requestova vezanih za FacilityContent.jsx
export default class FacilityUnitService {
    // GET-a podatke sa API-a "rsb-service/presentation/unit-first-part/{twoLetterISOLanguageCode}/{unitId}".
    // * unitID je required.
    // * lang se šalje samo sa SSR-a, zbog toga je opcionalan.
    static getPresentationUnitFirstPartData(unitID, lang) {
        const { presentationUnitFirstPartPath } = pageConfig.facilityUnitPage;

        return apiFetchData(presentationUnitFirstPartPath, `/${unitID}`, lang && lang);
    }

    // GET-a podatke sa API-a "rsb-service/presentation/unit-second-part/{twoLetterISOLanguageCode}/{unitId}".
    // * unitID je required.
    // * lang se šalje samo sa SSR-a, zbog toga je opcionalan.
    static getPresentationUnitSecondPartData(unitID, lang) {
        const { presentationUnitSecondPartPath } = pageConfig.facilityUnitPage;

        return apiFetchData(presentationUnitSecondPartPath, `/${unitID}`, lang && lang);
    }

    // GET-a podatke sa API-a "/presentation/unit/amenities/{twoLetterISOLanguageCode}/{unitId}".
    // * unitID je required.
    // * lang se šalje samo sa SSR-a, zbog toga je opcionalan.
    static getPresentationUnitAmenitiesData(unitID, lang) {
        const { presentationUnitAmenitiesPath } = pageConfig.facilityUnitPage;

        return apiFetchData(presentationUnitAmenitiesPath, `/${unitID}`, lang && lang);
    }

    // GET-a podatke sa API-a "/presentation/unit/reviews/{twoLetterISOLanguageCode}/{facilityId}/{offset}/{limit}".
    // * facilityID je required.
    // * lang se šalje samo sa SSR-a, zbog toga je opcionalan.
    static getFacilityUnitReviewsData(facilityID, offset, limit, lang) {
        const { presentationUnitReviewsPath } = pageConfig.facilityUnitPage;

        // Ako metoda ne primi parametre offset i limit, postavljamo ih na offset = 0, limit = 10.
        return apiFetchData(
            presentationUnitReviewsPath,
            `/${facilityID}/${offset || 0}/${limit || 10}`,
            lang && lang,
        );
    }

    // GET-a podatke sa API-a "/accommodation/facility-reviews/{twoLetterISOLanguageCode}/{facilityId}/{offset}/{limit}".
    // * facilityID je required.
    // * lang se šalje samo sa SSR-a, zbog toga je opcionalan.
    // Za recenzije jedinice koristimo recenzije objekta.
    static getFacilityReviewsData(facilityID, offset, limit, lang) {
        const { accommodationFacilityReviewsPath } = pageConfig.facilityUnitPage;

        // Ako metoda ne primi parametre offset i limit, postavljamo ih na offset = 0, limit = 10.
        return apiFetchData(
            accommodationFacilityReviewsPath,
            `/${facilityID}/${offset || 0}/${limit || 10}`,
            lang && lang,
        );
    }

    // GET-a podatke sa API-a "rsb-service/presentation/unit/reviews/{twoLetterISOLanguageCode}/{facilityId}/{offset}/{limit}".
    // * facilityID je required.
    // * lang se šalje samo sa SSR-a, zbog toga je opcionalan.
    static getPresentationUnitReviewsData(facilityID, offset, limit, lang) {
        const { presentationUnitReviewsPath } = pageConfig.facilityUnitPage;

        // Ako metoda ne primi parametre offset i limit, postavljamo ih na offset = 0, limit = 10.
        return apiFetchData(
            presentationUnitReviewsPath,
            `/${facilityID}/${offset || 0}/${limit || 10}`,
            lang && lang,
        );
    }

    // GET-a podatke sa API-a "/accommodation/facility/map-of-interests/{twoLetterISOLanguageCode}/{facilityId}".
    static getFacilityMapOfInterestsData(facilityID, lang) {
        const { accommodationFacilityMapOfInterestsPath } = pageConfig.facilityUnitPage;

        return apiFetchData(
            accommodationFacilityMapOfInterestsPath,
            `/${facilityID}`,
            lang && lang,
        );
    }

    // GET-a podatke sa API-a "/presentation/unit/main-gallery/{twoLetterISOLanguageCode}/{unitId}".
    static getPresentationUnitMainGalleryData(unitID, lang) {
        const { presentationUnitMainGalleryPath } = pageConfig.facilityUnitPage;

        return apiFetchData(
            presentationUnitMainGalleryPath,
            `/${unitID}`,
            lang && lang,
        );
    }

    // GET-a podatke sa API-a "rsb-service/presentation/unit/unit-gallery/{twoLetterISOLanguageCode}/{unitId}".
    static getPresentationUnitGalleryData(unitID, lang) {
        const { presentationUnitGalleryPath } = pageConfig.facilityUnitPage;

        return apiFetchData(
            presentationUnitGalleryPath,
            `/${unitID}`,
            lang && lang,
        );
    }

    // GET-a podatke sa API-a "rsb-service/presentation/unit/unit-overview/{twoLetterISOLanguageCode}/{unitId}".
    static getPresentationUnitOverview(unitID, lang) {
        const { presentationUnitOverviewPath } = pageConfig.facilityUnitPage;

        return apiFetchData(
            presentationUnitOverviewPath,
            `/${unitID}`,
            lang && lang,
        );
    }

    // GET-a podatke sa API-a "/presentation/unit/price-calculation-information/{twoLetterISOLanguageCode}/{unitCode}".
    static getPresentationUnitPriceCalculationInformation(unitIdWithQuery, lang) {
        const { presentationUnitPriceCalculationInformationPath } = pageConfig.facilityUnitPage;

        return apiFetchData(
            presentationUnitPriceCalculationInformationPath,
            `/${unitIdWithQuery}`,
            lang && lang,
        );
    }

    // GET-a podatke sa API-a "/presentation/unit/price-availability-calendar/{twoLetterISOLanguageCode}/{unitId}/{persons}/{numberOfMonths}/{month}".
    static getPresentationUnitPriceAvailabilityCalendarData(unitIdWithParameters, lang) {
        const { presentationUnitPriceAvailabilityCalendarPath } = pageConfig.facilityUnitPage;

        return apiFetchData(
            presentationUnitPriceAvailabilityCalendarPath,
            `/${unitIdWithParameters}`,
            lang && lang,
        );
    }

    // GET-a podatke sa API-a "/reservation/price-calculation-details/{twoLetterISOLanguageCode}".
    static getReservationPriceCalculationDetailsData(reservationParametersQuery, lang) {
        const { reservationPriceCalculationDetailsPath } = pageConfig.facilityUnitPage;

        return apiFetchData(
            reservationPriceCalculationDetailsPath,
            `${reservationParametersQuery}`,
            lang && lang,
        );
    }
}
